<template>
  <v-row wrap>
    <v-col>
      <v-btn
        class="white--text"
        color="#015594"
        @click="completeWorkshop"
        :disabled="finished"
      >
        {{ $t(`message.slideTwentyCompleteWorkshopBtn`) }}
      </v-btn>
      <br /><br />
      <v-alert type="success" v-if="finished">
        <b> {{ $t(`message.SuccessSubmit`) }} </b>
      </v-alert>
      <v-alert type="error" v-if="error">
        <b> {{ $t(`message.ErrorSubmit`) }} </b>
      </v-alert>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "CompleteWorkshopButton",
  data() {
    return {
      finished: false,
      error: false
    };
  },
  computed: {
    ...mapState("response", ["finalPayload"])
  },
  methods: {
    ...mapActions({
      addResponse: "response/addResponse"
    }),
    // completeWorkShop() {
    //   this.lookUpStakeholder({
    //     first_name: this.opttingIn
    //       ? this.stakeholderLookUpForm.first_name
    //       : "Anonymous",
    //     last_name: this.opttingIn
    //       ? this.stakeholderLookUpForm.last_name
    //       : "User",
    //     postal_code: this.stakeholderLookUpForm.postal_code
    //   });
    // }
    completeWorkshop() {
      const payload = {
        survey: 1, // On Demand Workshop
        survey_taker_id: 1, // anonymous user
        response_json: this.finalPayload,
        comment_location: [],
        survey_metadata: 1 // On Demand Workshop metadata
      };
      this.sending = true;
      this.addResponse(payload)
        .then(() => {
          this.finished = true;
          setTimeout(() => {
            this.finished = false;
          }, 5000);
        })
        .catch(() => {
          this.error = true;
          setTimeout(() => {
            this.error = false;
          }, 5000);
        });
    }
  }
};
</script>
